<script setup>
import LineIcon from "../../assets/line.png";

const props = defineProps({
    title: String,
    subtitle: String,
    sum: String
})
</script>

<template>
    <div class="line">
        <img class="icon" :src="LineIcon" alt="">

        <div>
            <h3 class="line-title">{{ $t(props.title, {money: props.sum}) }}</h3>
            <p class="line-subtitle">{{ $t(props.subtitle, {money: props.sum}) }}</p>
        </div>
    </div>
</template>

<style scoped>
.line {
    display: flex;
    align-items: flex-start;
    gap: 12px;
}

.line-title, .line-subtitle {
    margin: 0;
    line-height: 110%;
    color: #373737;
    font-size: 20px;
}

.line-title {
    font-weight: bold;
}

.line-subtitle {
    font-weight: 400;
}

.icon {
    width: auto;
    height: auto;
    
    margin-top: 5px;
}

@media screen and (max-width: 1280px) {
    .line-title, .line-subtitle {
        font-size: 16px;
    }
}
</style>